class ComponentCtrLpFaqSplit extends HTMLElement {
  connectedCallback() {
    this.allowMultiple = this.dataset.allowMultiple === 'true';
    this.bindItems();
  }

  bindItems() {
    this.abortItems?.abort();
    this.abortItems = new AbortController();

    this.querySelectorAll('.clfs-item').forEach((item) => {
      item.addEventListener(
        'click',
        (event) => {
          if (event.target.closest('a')) return;

          this.toggleItem(item);
        },
        { signal: this.abortItems.signal }
      );
    });
  }

  setItemState(item, isOpen) {
    const button = item.querySelector('.clfs-question');
    if (!button) return;

    item.classList.toggle('is-open', isOpen);
    button.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
  }

  toggleItem(item) {
    const isOpen = item.classList.contains('is-open');

    if (!this.allowMultiple && !isOpen) {
      this.querySelectorAll('.clfs-item.is-open').forEach((openItem) => {
        if (openItem !== item) {
          this.setItemState(openItem, false);
        }
      });
    }

    this.setItemState(item, !isOpen);
  }

  disconnectedCallback() {
    this.abortItems?.abort();
  }
}

customElements.define('component-ctr-lp-faq-split', ComponentCtrLpFaqSplit);
